<template>
    <div
    class="toggle"
    :class="{'toggle--on': value, 'toggle--off': !value, 'toggle--disabled': disabled, 'toggle--has-label': label}"
    :style="{'--width': width}">
        <label v-if="label" :for="id" class="toggle-label">
            {{ label }}
        </label>

        <div class="toggle-switch">
            <div class="toggle-switch__track">
                <span class="toggle-switch__handle"></span>
            </div>
            <span class="toggle-switch__text off">{{ offText }}</span>
            <span class="toggle-switch__text on">{{ onText }}</span>
            <input :disabled="disabled == true" class="toggle-switch__input" v-model="model" type="checkbox" :id="id"/>
        </div>
    </div>
</template>

<script>
import { v4 as uuid } from 'uuid'

export default {
    name: "Toggle",

    props: {
        value: Boolean,
        label: String,
        offText: String,
        onText: String,
        disabled: Boolean,
        width: {
            type: String,
            default: "80px"
        }
    },

    mounted() {
        this.id = uuid()
    },

    data() {
        return {
            id: ""
        }
    },

    computed: {
        model: {
            get() {
                return this.value
            },

            set(value) {
                this.$emit('input', value)
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.toggle {
    --height: 30px;
    --width: 90px;
    $transition: 0.2s ease;
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 10px;
    box-sizing: border-box;

    &-label {
        font-size: 0.875rem; /** 14px */
        color: white;
        font-weight: bold;
        width: 50%;
    }

    &-switch {
        flex-shrink: 0;
        box-sizing: border-box;
        background-color: $grey-7;
        position: relative;
        display: inline-block;
        border-radius: 15px;
        height: var(--height);
        width: var(--width);

        &__input {
            opacity: 0;
            cursor: pointer;
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            margin: 0;
        }

        &__track {
            position: absolute;
            top: 2px;
            left: 2px;
            width: calc(100% - 4px);
            height: calc(100% - 4px);
        }

        &__handle {
            height: calc(var(--height) - 4px);
            width: calc(var(--height) - 4px);
            border-radius: 50%;
            display: inline-block;
            background-color: #707070;
            position: absolute;
            transition: all $transition;

            transform: translateX(0);
            left: 0;
        }

        &__text {
            font-size: 0.75rem; /** 12px */
            color: white;
            text-transform: uppercase;
            font-weight: bold;
            position: absolute;
            top: 50%;
            transform: translateY(-50%);

            opacity: 1;
            transition: all $transition;

            &.on {
                left: 30px;
                opacity: 0;
            }
            &.off {
                left: calc(var(--height) + 8px);
            }
        }
    }

    &--has-label {
        width: 200px;
    }

    &--on {
        .toggle-switch {
            &__handle {
                left: 100%;
                transform: translateX(-100%);

                background-color: #42BF4D;
            }

            &__text {
                &.on {
                    opacity: 1;
                    left: 10px;
                }

                &.off {
                    opacity: 0;
                    left: calc(var(--height) - 30px);
                }
            }
        }
    }

    &--disabled {
        pointer-events: none !important;
        opacity: 0.5 !important;
        .toggle-switch {
            &__handle {
                background-color: #707070;
            }
        }
    }
}
</style>
